import Flux from 'lib/flux';

const ConversationConstants = Flux.createConstants({
  serviceMessages: ['CREATE'],
});

export default ConversationConstants;
